<template>
  
  <!-- <div class="group l_min-footspace" ref="sectionsGroup" data-id="sectionsGroup">
  
    <p>
      Editing Section <span v-html="builder.section"></span> of <span v-html="builder.sectionMax"></span>
    </p>
    
    <hr style="margin: 0;">
  </div> -->
  
  <Sections-Overview>
  </Sections-Overview>
  
  <component
    :is="comps.Size"
    :key="sectionComponentKey">
  </component>
  
  <component
    :is="comps.Configuration"
    :key="sectionComponentKey">
  </component>
  
</template>

<script setup>
  
import { computed } from 'vue'

import Size from "@/components/builder/products/kitchens/kitchen/Size.vue";
import Configuration from "@/components/builder/products/kitchens/kitchen/Configuration.vue";
import SectionsOverview from "@/components/builder/products/kitchens/kitchen/SectionsOverview.vue";

const comps = {
  Size,
  Configuration
};

const props = defineProps([])

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const sectionComponentKey = computed(() => {
  return 'Section' + builder.section;
})
</script>